module.exports = __webpack_public_path__ + "create/static/media/logo.1c530a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Logo/logo.png
// module id = 259
// module chunks = 39